import { findMessageLinks, toOpenableUrl } from '@/util/messageLinks';

/** A web address the thread will draw as a link: a scheme or `www.`, then a dotted host. */
const LINK_PATTERN = /^(https?:\/\/|www\.)[^\s.]+\.\S+$/i;

/** Whether a typed address is one the add-link sheet accepts. */
export function isValidLink(value: string): boolean {
  return LINK_PATTERN.test(value.trim());
}

/**
 * The text a support message is sent with: what the author typed, then each
 * added link on its own line. Links travel in the text rather than as a field
 * of their own, so a retry resends them unchanged and every reader, on any
 * build, sees the address even where it is not drawn as a link.
 */
export function messageBodyWithLinks(body: string, links: readonly string[]): string {
  if (links.length === 0) {
    return body;
  }

  const linkLines = links.join('\n');

  return body ? `${body}\n\n${linkLines}` : linkLines;
}

/** The most links one message unfurls, as Slack caps its own, so a list of links stays a message. */
export const MAX_LINK_PREVIEWS = 3;

/** The web links in a message's text worth unfurling, in order, each once. */
export function previewableLinks(body: string): string[] {
  const urls = findMessageLinks(body)
    .filter((link) => link.kind === 'url')
    .map((link) => toOpenableUrl(link.text));

  return [...new Set(urls)].slice(0, MAX_LINK_PREVIEWS);
}
